import { render, staticRenderFns } from "./nursePresAddXz.vue?vue&type=template&id=1f47c8c4&scoped=true"
import script from "./nursePresAddXz.vue?vue&type=script&lang=ts"
export * from "./nursePresAddXz.vue?vue&type=script&lang=ts"
import style0 from "./nursePresAddXz.vue?vue&type=style&index=0&id=1f47c8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f47c8c4",
  null
  
)

export default component.exports